<template>
    <div v-loading="exportLoading" element-loading-text="正在导出中，请稍等..." element-loading-spinner="el-icon-loading" class="sgtz">
        <div style="padding: 10px">
            <div style="padding-bottom: 15px; width: 100%; display: flex; justify-content: flex-end; background: white; position: relative; z-index: 999">
                <el-button-group>
                    <el-button size="small" icon="el-icon-refresh" @click="torefresh"></el-button>
                    <!-- <el-button size="small" plain icon="el-icon-plus" @click="addzdyzd">自定义字段</el-button> -->
                    <el-button size="small" plain @click="toExport">
                        <svg-icon icon-class="export" />
                        导出
                    </el-button>
                </el-button-group>
            </div>
            <template>
                <div v-loading="loading" element-loading-text="正在加载列表，请稍等...">
                    <div class="sgtz-main">
                        <el-table ref="singleTable" show-body-overflow show-header-overflow use-virtual :row-height="42" :max-height="550" :data="dataList" border :cell-style="{ height: '42px' }" style="width: 100%" @row-click="handleClick" @selection-change="handleSelectionChange">
                            <el-table-column type="selection" width="50" align="center" :show-overflow-tooltip="true" />
                            <el-table-column type="index" label="序号" width="40" align="center" />
                             <el-table-column prop="studentId" label="学号" align="left" :show-overflow-tooltip="true" width="120" />
                            <el-table-column prop="name" label="姓名" align="center" :show-overflow-tooltip="true" width="100" />
                            <el-table-column prop="studentGender" label="性别" align="center" :show-overflow-tooltip="true" width="80">
                                <template slot-scope="scope">
                                    <span class="tableColomm">{{ scope.row.hasGraduated == 1 ? '女' : '男' }}</span>
                                </template></el-table-column>
                            <el-table-column prop="className" label="班级" align="center" :show-overflow-tooltip="true" width="150" />
                            <el-table-column prop="majorSubcategory" label="专业子类" align="center" :show-overflow-tooltip="true" width="150" />
                            <el-table-column prop="majorName" label="专业大类" align="center" :show-overflow-tooltip="true" width="150" />
                            <el-table-column prop="teacherName" label="班主任" align="center" :show-overflow-tooltip="true" width="100" />
                            <el-table-column v-for="(option, optionKey) in tableColumn" :key="optionKey" :prop="option" :label="option" width="100" align="center" :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    <span class="tableColomm">{{ getValue(scope.row.passenger.leaveMarkName[optionKey]) }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="hasGraduated"
                                label="是否离校"
                                align="center"
                                :show-overflow-tooltip="true"
                                width="100"
>
                            <template slot-scope="scope">
                                    <span class="tableColomm">{{ scope.row.hasGraduated == 1 ? '是' : '否' }}</span>
                                </template></el-table-column>
                            <el-table-column prop="type" label="离校类型" align="center" :show-overflow-tooltip="true" width="100" />
                            <el-table-column prop="graduationCertificateNumber" label="毕业证编号" align="center" :show-overflow-tooltip="true" width="150" />
                            <el-table-column prop="leaveTime" label="离校时间" align="center" :show-overflow-tooltip="true" width="150" />
                            <el-table-column prop="remarks" label="备注" align="center" :show-overflow-tooltip="true" width="120" />
                            <el-table-column prop="createBy" label="处理人" align="center" :show-overflow-tooltip="true" width="80" />
                            <el-table-column prop="createTime" label="处理时间" align="center" :show-overflow-tooltip="true" width="150" />
                        </el-table>
                    </div>
                </div>
            </template>
        </div>
        <el-pagination v-if="dataList.length > 0" style="margin-bottom: 10px" align="right" :current-page="currentPage" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pageTotal" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>
</template>

<script>
import { get } from 'sortablejs'

export default {
    props: {},
    data() {
        return {
            dataList: [],
            loading: false,
            exportLoading: false,
            tableColumn: [],
            multipleSelection: '',
            currentPage: 1,
            SearchVisible: false,
            pageTotal: 0,
            pageSize: 10,
            rowData: {},
            mySalaryDetailDialogShow: false
        }
    },
    computed: {},
    watch: {},
    created() {
        this.getList()
    },
    beforeDestroy() {},
    mounted() {},
    methods: {
        getValue(val) {
            if (val.isExecute == 1) {
                return '✔'
            }
        },
        getList() {
            this.loading = true
            this.$http({
                contentType: 'application/x-www-form-urlencoded',
                method: 'post',
                url: '/xsgl/studentGraduationRecords/listdata',
                params: {
                    pageSize: this.pageSize,
                    pageNum: this.currentPage,
                    hasGraduated: 1
                    // orderBy: 'orgFullOrderNo asc',
                }
            }).then((res) => {
                if (res.code === 'success') {
                    let tbColumns = res.body.leaveMarkName
                    tbColumns.forEach((item, index) => {
                        $scope.$props.tbColumns.splice(9 + index, 0, {
                            align: 'center',
                            enabled: true,
                            field: item,
                            fixed: false,
                            listAdvSearchElement: 'input',
                            listAdvSearchIndex: 5,
                            propFormatter: '',
                            propType: 'String',
                            searchable: true,
                            sortable: false,
                            title: item,
                            width: '120px'
                        })
                    })
                }
            })
        },
        etChineseLength(str) {
            let len = 0
            for (let i = 0; i < str.length; i++) {
                if (str.charCodeAt(i) > 127 || str.charCodeAt(i) === 94) {
                    len += 1 // 如果字符是中文字符，增加2
                }
            }
            return len
        },
        handleClick(val) {
            this.rowData = val
            this.mySalaryDetailDialogShow = true
        },
        toExport() {
            window.open('/apigw/hrxc/salaryAccountingEmployee/exportData?pageSize=9999&pageNum=1&orderBy=orgFullOrderNo asc&accountingId=' + this.$route.query.rowId, '_blank')
        },
        addzdyzd() {
            this.$bus.emit('zdyzdopendialog', 4)
        },
        torefresh() {
            this.getList()
        },
        // 条数更改
        handleSizeChange(val) {
            // this.currentPage = 1
            this.pageSize = val
            this.getList()
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.getList()
        },
        // 选择
        handleSelectionChange(val) {
            this.multipleSelection = val
            console.log(this.multipleSelection, 'this.,dsfa')
        },

        /**
         * 加载数据准备，qparams为查询参数对象，不需要返回值
         */
        onListDataBeforeLoad($scope, qparams) {
            this.loginUser = $scope.loginUser

            console.log($scope, qparams, 'role listdata before load..')
        },
        /**
         * 加载数据完成，pageInfo为包含查询结果的分页信息对象，不需要返回值
         */
        onListDataLoaded($scope, pageInfo) {
            console.log($scope, pageInfo, 'role listdata loaded')
        },
        /**
         * 表单打开检查，vo为已加载role对象，允许打开：defer.resolve(true)，阻止打开：defer.reject(reason)
         */
        onBasicFormBeforeOpen($scope, vo, defer) {
            console.log('role form before open')
            defer.resolve(true)
        },
        toBack() {
            this.$router.go(-1)
        },
        formatDate(dateStr) {
            const date = new Date(dateStr)
            const year = date.getFullYear()
            const month = date.getMonth() + 1 // 月份从0开始
            const day = date.getDate()
            return `${year}年${month}月`
        }
    }
}
</script>

<style scoped lang="scss">
.sgtz {
    position: relative;

    .mb-10 {
        margin-bottom: 10px;
    }

    .sgtz-main {
        width: 100%;

        /deep/.el-table__body-wrapper {
            /* 设置滚动条thumb（轨道）的颜色 */
            scrollbar-width: auto;

            &::-webkit-scrollbar-thumb {
                background-color: #929292;
                border-radius: 12px;
            }

            /* 增加滚动条的宽度，高度 */
            &::-webkit-scrollbar {
                width: 12px;
                height: 12px;
            }

            /* 设置滚动条hover时thumb的颜色 */
            &::-webkit-scrollbar-thumb:hover {
                background-color: #dbdbdb;
                cursor: pointer;
            }
        }
    }

    /* 设置滚动条thumb（轨道）的颜色 */
    &::-webkit-scrollbar {
        background-color: #f0f2f5;
        width: 8px;
    }

    /* 设置滚动条thumb（滑块）的颜色 */
    &::-webkit-scrollbar-thumb {
        border-radius: 12px;
    }

    /deep/.el-tabs__nav-wrap::after {
        background-color: #ebeef5 !important;
    }

    /deep/.el-tabs__header {
        margin: 0 !important;
    }
}

.el-table.el-table--border td {
    cursor: auto;
}

.navbar-search {
    z-index: 0;
    display: flex;
    position: absolute;
    float: inline-end;
    overflow: hidden;
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    justify-content: end;
    top: -40px;
    right: 21px;

    .search-icon {
        cursor: pointer;
        font-size: 16px;
        vertical-align: middle;
        color: #4a4a4a;
        // margin-left: 5px;
        // position: relative;
        // z-index: 5;
    }

    .disabled_icon {
        cursor: default;
    }

    .search-input {
        font-size: 13px;
        width: 170px;
        float: left;
        margin-right: 5px;

        /deep/ .el-input__inner {
            padding: 0 10px;
        }

        /deep/ .el-input-group__append {
            padding: 0 10px;
            font-size: 12px;
            background: #f3f4f4;

            .search-icon {
                width: 12px;
                height: 12px;
            }
        }
    }

    .advanced-btn {
        float: left;
        position: relative;
        color: #4a4a4a;
        background-color: #f3f4f4;
        border-color: #dee2e6;
    }
}

.dragpanel-container {
    width: 95%;
    margin: 0 auto;
}

.panel-footer {
    text-align: center;
    margin-top: 10px;
}

.color {
    color: #ffffff;
    background-color: #1a82e3;
}

/deep/.el-table--enable-row-transition .el-table__body td.el-table__cell {
    background-color: #ffffff;
}

/deep/.el-table__fixed::before {
    z-index: 0;
}

/deep/.el-table__fixed-right::before {
    z-index: 0;
}

/deep/.el-table thead.is-group th.el-table__cell {
    background: #f2f5fb;
    color: #000;
}

/deep/.el-table .el-table__header-wrapper .el-table__header thead th {
    color: #000;
}

/deep/.el-table th.el-table__cell {
    background: #f2f5fb !important;
}

/deep/.el-table th.el-table__cell > .cell {
    color: #000;
}

/deep/.el-link.el-link--primary.is-disabled {
    color: #9e9e9e !important;
}

/deep/.plTableBox .el-table td,
.plTableBox .el-table th {
    padding: 8px 0 !important;
}

/deep/.plTableBox .el-table--border th {
    border-bottom: 1px solid #ebeef5;
    background-color: #f2f5fb;
    border-right-color: #d8d8d8;
    border-bottom-color: #dee2e6;
    color: #000;
}

/deep/.plTableBox .el-table--fluid-height .el-table__fixed,
.plTableBox .el-table--fluid-height .el-table__fixed-right {
    height: calc(100% - 12px);
}

/deep/.plTableBox .el-table .cell {
    padding: 0px 1px !important;
}

/deep/.plTableBox .el-table .umy-table-beyond {
    text-align: center;
}

/deep/.plTableBox .el-table .cell.el-tooltip {
    min-width: 30px;
}

/deep/.plTableBox .el-table .cell .el-link {
    padding-left: 0;
}

.noneDataListStyle {
    /deep/.is-scrolling-none {
        height: 12px;
    }

    /deep/.is-scrolling-left {
        height: 12px;
    }

    /deep/.is-scrolling-middle {
        height: 12px;
    }

    /deep/.is-scrolling-right {
        height: 12px;
    }
}
</style>
